<template>
  <div class="general-form-wrap social-info-wrap box-wrapper">
    <div class="social-form-wrap">
      <div class="heading">
        <h2 class="form-title">Social Media</h2>
      </div>
      <FormModel layout="horizontal" :model="resource" @submit="handleSubmit">
        <a-row :gutter="32">
          <a-col :sm="8">
            <BaseFormInput
              name="facebook"
              placeholder="Enter Facebook Link"
              :value="resource.facebook"
              @change="
                event => handleFormItemChange('facebook', event.target.value)
              "
            />
          </a-col>
          <a-col :sm="8">
            <BaseFormInput
              name="instagram"
              placeholder="Enter Instagram Link"
              :value="resource.instagram"
              @change="
                event => handleFormItemChange('instagram', event.target.value)
              "
            />
          </a-col>
          <a-col :sm="8">
            <BaseFormInput
              name="twitter"
              placeholder="Enter Twitter Link"
              :value="resource.twitter"
              @change="
                event => handleFormItemChange('twitter', event.target.value)
              "
            />
          </a-col>
          <a-col :sm="8">
            <BaseFormInput
              name="linkedin"
              placeholder="Enter Linkedin link"
              :value="resource.linkedin"
              @change="
                event => handleFormItemChange('linkedin', event.target.value)
              "
            />
          </a-col>
          <a-col :sm="8">
            <BaseFormInput
              name="flickr"
              placeholder="Enter Flickr Link"
              :value="resource.flickr"
              @change="
                event => handleFormItemChange('flickr', event.target.value)
              "
            />
          </a-col>
          <a-col :sm="8">
            <BaseFormInput
              name="podcast"
              placeholder="Enter Podcast link"
              :value="resource.podcast"
              @change="
                event => handleFormItemChange('podcast', event.target.value)
              "
            />
          </a-col>
        </a-row>
        <a-form-item>
          <a-button
            type="primary"
            html-type="submit"
            class="next-button first-save-button"
            >Save And Continue</a-button
          >
          <a-button
            type="primary"
            @click="handleStepSkip"
            class="next-button second-skip-button"
            >Skip</a-button
          >
        </a-form-item>
      </FormModel>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { FormModel } from "ant-design-vue";
import { Athlete } from "@/models";

const STORE_KEY = "athleteStore";

export default {
  data() {
    return {
      resource: new Athlete({})
    };
  },
  mounted() {
    this.dispatcher();
  },
  components: {
    FormModel
  },
  computed: {
    ...mapGetters({
      athlete: `${STORE_KEY}/athlete`,
      athleteLoading: `${STORE_KEY}/athleteLoading`
    }),
    athleteId() {
      return this.id || this.$route.params.id;
    },
    disableButton() {
      return this.resource.facebook ||
        this.resource.linkedin ||
        this.resource.podcast ||
        this.resource.instagram ||
        this.resource.twitter ||
        this.resource.flickr
        ? false
        : true;
    }
  },
  methods: {
    validateForm() {
      return true;
    },
    handleFormItemChange(key, value) {
      this.resource = new Athlete({ ...this.resource, [key]: value });
    },
    dispatcher() {
      this.$store.dispatch(`${STORE_KEY}/getAthlete`, { id: this.athleteId });
    },
    async handleSubmit(e) {
      e.preventDefault();
      await this.$store.dispatch(`${STORE_KEY}/updateAthlete`, {
        id: this.athleteId,
        facebook: this.resource.facebook,
        instagram: this.resource.instagram,
        podcast: this.resource.podcast,
        flickr: this.resource.flickr,
        linkedin: this.resource.linkedin,
        slug: "athlete",
        registerPageCompleted: 7,
        message: "Social Media  Added to Profile"
      });
      this.$emit("save", this.athlete.registerPageCompleted);
    },
    handleStepSkip() {
      this.$emit("save", 7);
    }
  },
  watch: {
    athlete(newVal, _) {
      this.resource = new Athlete(newVal);
    }
  }
};
</script>
<style lang="scss"></style>
